(()=>{
  document.querySelectorAll('[data-hoodie-reveal]').forEach(root=>{
    if(root.dataset.ready)return;root.dataset.ready='true';
    const video=root.querySelector('video'),button=root.querySelector('button');
    const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible=false,manualPause=false;
    const label=()=>{button.textContent=video.paused?'Pokreni prikaz':'Pauziraj prikaz';button.setAttribute('aria-label',button.textContent);};
    const start=()=>{if(!visible||document.hidden||manualPause||motion.matches)return;video.play().catch(label);};
    video.addEventListener('play',label);video.addEventListener('pause',label);
    button.addEventListener('click',()=>{if(video.paused){manualPause=false;video.play().catch(label);}else{manualPause=true;video.pause();}});
    new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)start();else video.pause();},{threshold:.25}).observe(video);
    motion.addEventListener('change',()=>{if(motion.matches)video.pause();else start();});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else start();});
    label();
  });
})();
